import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectsModel,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
  TargetColumnValue,
  TargetObjectData,
} from "@barthauer/abc/core/data";

import { MatTooltipModule } from "@angular/material/tooltip";
import {
  AbcCoreContainerService,
  AbcDateBoxComponent,
  AbcNumberBoxComponent,
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  AbcTextBoxComponent,
  ScrollMode,
  ValidationStatus,
  _AbcButtonComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcScrollViewComponent,
  _AbcSelectBoxComponent,
  _AbcTagBoxComponent,
  _AbcTreeComponent,
} from "@barthauer/abc/ui-components";
import { ProfileInfo } from "@barthauer/basys/core/authentication";
import {
  Measure,
  MeasureProgress,
  MeasureTask,
  NotificationMessage,
  Resource,
  SubProject,
} from "@barthauer/custom/xmt-models";
import {
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxNumberBoxModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTextBoxModule,
} from "devextreme-angular";
import config from "devextreme/core/config";
import repaintFloatingActionButton from "devextreme/ui/speed_dial_action/repaint_floating_action_button";
import { forkJoin, from, Observable, of, Subscription } from "rxjs";
import { first, map, switchMap } from "rxjs/operators";
import {
  ActionType,
  PermissionContext,
  ROLES,
  ToastType,
} from "../../../models/enumeration-list.model";
import { AppService } from "../../../services/app.service";
import { DataService, ObjectKeys } from "../../../services/data.service";
import { NotificationService } from "../../../services/notification.service";
import { SharedModule } from "../../../shared/shared.module";
import { MeasureTaskViewModel } from "../../../view-models/measure-task.view-model";
import { MeasureService } from "../measure.service";
import { ChartComponent } from "./chart/chart.component";
import { DescriptionComponent } from "./description/description.component";
import { ImplementationPlanComponent } from "./implementation-plan/implementation-plan.component";
import { StatusReportComponent } from "./status-report/status-report.component";
import { TotalTimeComponent } from "./totalTime/total-time.component";
import { BasedRoleOPathService } from "../../../services/based-role-opath.service";
import { StuffMemberPerson } from "../measure.model";
import { ApprovalRequest } from "./approval-request/approval-request.component";
import { MeasureEvaluationComponent } from "./measurre-evaluation/measure-evaluation.component";
import { Comment } from "../../../shared/comment/models/comment.model";
import {
  NotificationService1,
  EmailNotificationDescriptions,
  EmailNotificationSubjects,
  EmailNotificationType,
} from "../../../services/notification1.service";
import { EURO_SVG, ICON_SVG } from "../../../shared/assets/icons";
import { TabPanelComponent } from "./tab-panel/tab-panel.component";
import { formatMessage } from "devextreme/localization";
import { AIMSROUTES } from "../../../../app-routing.module";
import { LanguageService } from "../../../services/language.service";
import { DocumentService } from "../../../shared/document/document.service";
import { ObjectTypeService } from "../../../services/object-type.service";
@Component({
  selector: "ubt-geods-measure-detail",
  templateUrl: "./measure-detail.component.html",
  styleUrls: ["./measure-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DxFormModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxButtonModule,
    _AbcScrollViewComponent,
    DxScrollViewModule,
    DxTagBoxModule,
    _AbcTagBoxComponent,
    AbcDateBoxComponent,
    _AbcSelectBoxComponent,
    AbcTextBoxComponent,
    StatusReportComponent,
    ImplementationPlanComponent,
    ChartComponent,
    TotalTimeComponent,
    DescriptionComponent,
    MatTooltipModule,
    SharedModule,
    _AbcButtonComponent,
    DxDataGridModule,
    ApprovalRequest,
    MeasureEvaluationComponent,
    TabPanelComponent,
  ],
  providers: [AbcCoreContainerService, MeasureService],
})
export class MeasureDetailComponent implements OnInit, OnDestroy {
  @ViewChild("addDocumentSelectBox")
  addDocumentSelectBox: _AbcSelectBoxComponent;
  @ViewChild("confirmPopup") confirmPopup: AbcPopupComponent;
  @ViewChild("confirmTaskPopup") confirmTaskPopup: AbcPopupComponent;
  @ViewChild("efficiencyField") efficiencyField: AbcNumberBoxComponent;
  @ViewChild("measureTitle") measureTitle: AbcTextBoxComponent;
  @ViewChild("chart") chart: ChartComponent;
  @ViewChild("commentsPopup") commentsPopup: AbcSpeedDialActionComponent;
  @ViewChild("assignedMembers") assignedMembers: _AbcTagBoxComponent;
  @ViewChild("statusReport") statusReport: StatusReportComponent;
  public showImpl = false;
  protected iconSvg = ICON_SVG;
  protected euroSvg = EURO_SVG;
  public implementationPlan: ImplementationPlanComponent;
  public showTaskParents = false;
  public isNewTask: boolean;
  public subProjects: SubProject[] = [];
  public measure: Measure = new Measure(null);
  public isNewMeasureTask = false;
  public lastMeasureProgress: MeasureProgress = new MeasureProgress(null);
  public allComments: Comment;
  public workOnLastStatus = false;
  public toogleTitleVisible = false;
  public toogleInformations = false;
  public createSecondMeasureTask = false;
  public updateTaskMode = false;
  public navigationMaximumIndex: number;
  public measureComments: Comment[];
  public allowedParentTasks: MeasureTask[] = [];
  public assignedMembersIds: string[] = [];
  public assignedResource: Resource = new Resource(null);
  public documents = [];
  public responsibles: ProfileInfo[] = [];
  public status = ValidationStatus;
  public isAutoAdjust = false;
  public measureTasks: MeasureTaskViewModel[] = [];
  public scrollMode: ScrollMode = ScrollMode.Standard;
  public submitButtonText: string;
  public measureId: string;
  public collaboratorsList = [];
  public collaboratorsTotalTime = [];
  private returnPath: string;
  private subscriptions: Subscription[] = [];
  private measureProgressColumns: QueryColumn[] = [];
  private measureColumns: QueryColumn[] = [];
  public allowUpdating = true;
  public nextMeasureDesignation: string;
  public previousMeasureDesignation: string;
  public SubPojectName: string;
  public ROLES = ROLES;
  public coreTeamSupervisorDataSource: StuffMemberPerson[] = [];
  public cachedResponsibles: StuffMemberPerson[] = [];
  private ratingComment: Comment = new Comment(null);
  public permissions = {
    canManageStatusReport: false,
    canEditDescription: false,
    canEditMeasureInfos: false,
    canManageMilestones: false,
    canManageTasks: false,
    canCreateApprovalRequest: false,
    canApproveRequestStep1: false,
    canApproveRequestStep2: false,
    canChangeHartegrad: false,
  };

  private measurePermissionMap = {
    canEditDescription: "Description",
    canEditMeasureInfos: "Infos",
    canManageStatusReport: "StatusReport",
    canManageTasks: "Tasks",
    canManageMilestones: "MileStones",
    canCreateApprovalRequest: "CreateApprovalRequest",
    canApproveRequestStep1: "ApprovalRequestStep1",
    canApproveRequestStep2: "ApprovalRequestStep2",
    canChangeHartegrad: "ChangeHartegrad",
  };
  protected isViewReady: boolean = false;
  protected currentProgressIndex = this.appService.currentMeasureProgressIndex;
  protected measureStatusOptions: Array<{ name: string; value: string }> = [];
  protected isDesktop = signal(window.innerWidth >= 1001);
  constructor(
    private activatedRoute: ActivatedRoute,
    public dataService: DataService,
    public appService: AppService,
    private coreDataService: CoreDataService,
    private persistenceService: PersistenceService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public measureService: MeasureService,
    private notificationService: NotificationService,
    private notificationService1: NotificationService1,
    private opathService: BasedRoleOPathService,
    private languageService: LanguageService,
    private documentService: DocumentService,
    private objectTypeService: ObjectTypeService,
  ) {
    this.checkMeasurePermissions();
    this.measureId = this.activatedRoute.snapshot.params.id;
    measureService.currentMeasureId.set(this.measureId);
    sessionStorage.setItem("measureId", this.measureId);
    this.returnPath = this.activatedRoute.snapshot.params.from;
  }
  @HostListener("window:resize")
  onResize() {
    this.isDesktop.set(window.innerWidth >= 1001);
  }
  public ngOnInit(): void {
    this.dataService.favoriteMeasureId$.subscribe((measureId: string) => {
      this.measureId = measureId;
      this.prepareCurrentMeasure();
    });
    this.appService.showLoader(true);
    config({
      floatingActionButtonConfig: {
        icon: "rowfield",
        shading: true,
        position: {
          of: "#grid",
          my: "right bottom",
          at: "right bottom",
          offset: "-16 -16",
        },
      },
    });
    repaintFloatingActionButton();
    const subProjectColumns = [
      this.coreDataService.createQueryColumn(
        "Id",
        "Id",
        QueryColumnSortOrder.None,
      ),
      this.coreDataService.createQueryColumn(
        "Designation",
        "Label",
        QueryColumnSortOrder.None,
      ),
    ];
    const subProjectOPath =
      "ParentId=" + "'" + sessionStorage.getItem("projectId") + "'";
    this.subscriptions.push(
      this.dataService
        .readObjects<
          SubProject[]
        >(ObjectKeys.SUBPROJECT, subProjectColumns, this.checkSubprojectOpath())
        .subscribe((subProjects: any) => {
          this.subProjects = subProjects.sort((a, b) =>
            a.Label.localeCompare(b.Label),
          );
        }),
    );

    this.prepareCurrentMeasure();

    if (this.appService.measureIds.length === 0) {
      this.prepareMeasureIds();
    } else {
      this.prepareMeasureDesignation();
      this.prepareNavigationIndex();
    }
    this.initializeMeasureStatusOptions();
  }
  private initializeMeasureStatusOptions(): void {
    this.measureStatusOptions = this.measureService.measureStatus.map(
      (status) => ({
        name: this.dataService.res(`Ubt-Measure-List-${status.name}`),
        value: status.value,
      }),
    );
  }

  private checkMeasurePermissions(): void {
    Object.entries(this.measurePermissionMap).forEach(([key, context]) => {
      this.permissions[key] = this.dataService.hasPermission(
        PermissionContext.Measure,
        ActionType.SEE,
      );
    });
  }

  private prepareCurrentMeasure() {
    forkJoin([
      this.dataService.prepareStaffMembers(),

      this.coreDataService.executeReadObjectsQuery(
        this.prepareMeasureDetailColumns(this.measureId),
      ),
    ])
      .pipe(first())
      .subscribe(
        (data) => {
          this.measureService.collaboratorsColumns = [
            {
              caption: this.dataService.res("Ubt-CreateMeasure-Members"),
              dataField: "IdRefMember",
              lookup: {
                valueExpr: "Id",
                displayExpr: "Person",
                dataSource: data[1][0]?.MeasureResources?.sort((a, b) =>
                  a.Person.localeCompare(b.Person),
                ),
              },
              sortOrder: "asc",
            },
            {
              caption: this.dataService.res(
                "Ubt-Collaborator-Total-Time-Planned",
              ),
              dataField: "TimePlanned",
              dataType: "number",
              format: "#,##0 h",
              alignment: "center",
              width: "25%",
            },
            {
              caption: this.dataService.res(
                "Ubt-Collaborator-Total-Time-Executed",
              ),
              dataField: "TimeExecuted",
              dataType: "number",
              format: "#,##0 h",
              alignment: "center",
              width: "25%",
            },
          ];

          this.measureService.collaboratorsTotalTimeColumns = [
            {
              caption: this.dataService.res("Ubt-CreateMeasure-Members"),
              dataField: "name",
              lookup: {
                valueExpr: "Id",
                displayExpr: "Person",
                dataSource: data[1][0].MeasureResources,
              },
              sortOrder: "asc",
            },
            {
              caption: this.dataService.res(
                "Ubt-Collaborator-Total-Time-label",
              ),
              dataField: "sum",
              dataType: "number",
              format: "#,##0 h",
              alignment: "right",
              width: "40%",
            },
          ];
          if (
            Array.isArray(data) &&
            data.length > 0 &&
            Array.isArray(data[0]) &&
            data[0].length > 1
          ) {
            const stuffmemberList = data[0];
            this.measureService.getStuffMemberDataSource(stuffmemberList);
            this.measureService.getMeasureResponsibleDataSource(
              stuffmemberList,
            );
            this.coreTeamSupervisorDataSource =
              this.measureService.getCoreTeamSupervisorDataSource(
                stuffmemberList,
              );
            this.dataService.cachedResponsiblesResponse =
              this.cachedResponsibles = data[0]?.sort((a, b) =>
                a.LastName.localeCompare(b.LastName),
              );
          }

          this.measure = data[1][0];
          this.measureService.currentMeasure.set({
            ...this.measure,
            comment: data[1][0]?.["Comment"]?.[0],
          });
          const isStrategieteamAndResponsible =
            this.measureService.isStrategieteamAndResponsible(
              data[1][0].Responsible,
            );
          if (isStrategieteamAndResponsible) {
            this.permissions.canEditDescription = true;
            this.permissions.canEditMeasureInfos = true;
            this.permissions.canManageStatusReport = true;
            this.permissions.canManageTasks = true;
            this.permissions.canManageMilestones = true;
          }
          const subProjectColumns = [
            this.coreDataService.createQueryColumn(
              "Id",
              "Id",
              QueryColumnSortOrder.None,
            ),
            this.coreDataService.createQueryColumn(
              "Designation",
              "Designation",
              QueryColumnSortOrder.None,
            ),
          ];
          const subProjectOPath = `ParentId='${sessionStorage.getItem("projectId")}' And Id ='${this.measure.ParentId}'`;
          this.subscriptions.push(
            this.dataService
              .readObjects<
                SubProject[]
              >(ObjectKeys.SUBPROJECT, subProjectColumns, subProjectOPath)
              .subscribe((subProjects: any) => {
                this.SubPojectName = subProjects[0].Designation;
                this.appService.subProjectName.set(this.SubPojectName);
              }),
          );
          if (this.appService.loadNotOnlyMeasureDetails) {
            this.showImpl = true;
          }
          if (!this.measure.MeasureResources) {
            //TODO IdRefMember column datasource needs to be initialized to empty array if it was undefined
            this.measure.MeasureResources = [];
          }
          this.appService.measureName.set(this.measure.Title);
          this.assignedMembersIds = [];
          if (!this.measure.MeasureResources) {
            this.measure.MeasureResources = [];
          } else {
            this.measure.MeasureResources?.forEach((resource) => {
              const member = this.dataService.cachedResponsiblesResponse.find(
                (responsible) => responsible.Id === resource.Member,
              );
              if (member?.Id !== undefined) {
                this.assignedMembersIds.push(member?.Id);
              }
            });
          }

          this.documentService.documentsNumber.set(
            this.measure["documentsNumber"],
          );

          this.loadMeasureProgress();
          this.collaboratorsTotalTime =
            this.measureService.calculateOverAllTime(this.measure);
        },
        (error) => {
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
          console.error(error);
        },
        () => {
          this.appService.showLoader(false);
          this.appService.loadMeasureDetails = false;
          this.isViewReady = true;
          this.cdr.markForCheck();
        },
      );
  }

  public verifyChanges(event, columnName): void {
    if (event.event) {
      switch (columnName) {
        case "Designation":
          if (event.value !== "") {
            this.measureService.updateMeasure(
              "Designation",
              event.value,
              this.allowUpdating,
            );
          } else {
            this.measureTitle.value = event.previousValue;
          }
          break;

        case "EndDate":
          this.measureService.updateMeasure(
            "EndDate",
            event.value,
            this.allowUpdating,
          );
          this.allowUpdating = true;
          break;
        case "ParentId":
          this.measureService.updateMeasure(
            "ParentId",
            event.value,
            this.allowUpdating,
          );
          break;
        case "Status":
          this.measureService.updateMeasure(
            "Status",
            event.value,
            this.allowUpdating,
          );
          break;
        case "IdRefPersonResponsible":
          this.measureService.updateMeasure(
            "IdRefPersonResponsible",
            event.value,
            this.allowUpdating,
          );
          break;
        case "IdRefPersonSponsor":
          this.measureService.updateMeasure(
            "IdRefPersonSponsor",
            event.value,
            this.allowUpdating,
          );
          break;
        case "IdRefPersonAreaManager":
          this.measureService.updateMeasure(
            "IdRefPersonAreaManager",
            event.value,
            this.allowUpdating,
          );
          break;
        case "StartDate":
          this.measureService.updateMeasure(
            "StartDate",
            event.value,
            this.allowUpdating,
          );
          break;
        case "ReleaseDate":
          this.measureService.updateMeasure(
            "ReleaseDate",
            event.value,
            this.allowUpdating,
          );
          break;
      }
    }
  }
  public addDeleteResource(event): void {
    if (event.addedItems.length > 0) {
      const areTheyNew = event.addedItems.every((newMember) => {
        const index = this.measure.MeasureResources.findIndex(
          (item) => item.Member === newMember.Id,
        );
        return index === -1;
      });
      if (areTheyNew) {
        this.persistResource(event.addedItems)
          .pipe(
            switchMap((result) => {
              const userIds = event.addedItems.map((item) => item.Id);
              return forkJoin(
                userIds.map((userId) =>
                  this.notificationService1
                    .getNotificationSettings(userId)
                    .pipe(
                      map((types) =>
                        this.notificationService1.parseNotificationSettings(
                          types,
                        ),
                      ),
                      switchMap((settings) => {
                        const inApp$ = settings.notificationInApp
                          ? this.notificationService1.createNotifications([
                              {
                                ParentId: this.measureId,
                                ParentObjectType: this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE),
                                Comment: "notification.Measure-UserAssigned",
                                Text: "",
                                UserIdList: [userId],
                              },
                            ])
                          : of(null);
                        const email$ = settings.notificationByEmail
                          ? this.dataService
                              .readObjects(
                                ObjectKeys.PERSON,
                                [
                                  this.coreDataService.createQueryColumn(
                                    "Id",
                                    "Id",
                                  ),
                                  this.coreDataService.createQueryColumn(
                                    "EMail",
                                    "EMail",
                                  ),
                                ],
                                `Id='${userId}'`,
                              )
                              .pipe(
                                switchMap((persons: any[]) => {
                                  const person = persons?.[0];
                                  const email = person?.EMail;

                                  if (!email) return of(null);

                                  return from(
                                    this.languageService.translateBulk(
                                      [
                                        {
                                          field: "subject",
                                          key: EmailNotificationSubjects.MEASURE_USER_ASSIGNED,
                                        },
                                        {
                                          field: "description",
                                          key: EmailNotificationDescriptions.MEASURE_USER_ASSIGNED,
                                          params: { 0: this.measure.Title },
                                        },
                                        {
                                          field: "notificationType",
                                          key: EmailNotificationType.MEASURE_USER_ASSIGNED,
                                        },
                                      ],
                                      settings.language,
                                    ),
                                  ).pipe(
                                    switchMap((translations) => {
                                      const redirectUrl =
                                        this.dataService.generateRedirectionUrl(
                                          AIMSROUTES.MEASURE_DETAIL,
                                          [AIMSROUTES.MEASURES, this.measureId],
                                        );

                                      const content = {
                                        notificationType:
                                          translations.notificationType,
                                        description: translations.description,
                                        redirectUrl,
                                      };

                                      return this.notificationService1.sendNotificationEmail(
                                        content,
                                        translations.subject,
                                        email,
                                        settings.language,
                                      );
                                    }),
                                  );
                                }),
                              )
                          : of(null);
                        return forkJoin([inApp$, email$]);
                      }),
                    ),
                ),
              ).pipe(map(() => result));
            }),
          )
          .subscribe(
            (persistedResources) => {
              if (
                Array.isArray(persistedResources) &&
                persistedResources.length > 0
              ) {
                if (
                  Array.isArray(persistedResources[0]) &&
                  persistedResources[0].length > 0
                )
                  persistedResources[0]?.forEach((persistedResource, index) => {
                    const member = event.addedItems[index];
                    const resource = new Resource(null);
                    resource.Id = persistedResource.Id;
                    resource.Member = member.Id;
                    resource["Person"] =
                      member.FirstName + ", " + member.LastName;
                    this.measure.MeasureResources.push(resource);
                  });
              }
            },
            (error) => {},
            () => {
              this.cdr.markForCheck();
            },
          );
      }
    }
    if (
      event.removedItems.length > 0 &&
      this.measure.MeasureResources.length > 0
    ) {
      this.subscriptions.push(
        this.deleteResources(event.removedItems).subscribe((removedData) => {
          event.removedItems.forEach((removedItem) => {
            const index = this.measure.MeasureResources.findIndex(
              (item) => item.Member === removedItem.Id,
            );
            this.measure.MeasureResources.splice(index, 1);
          });
        }),
      );
    }
  }

  private deleteResources(removedMembers: any[]): Observable<any> {
    const query: PersistObjectsModel = new PersistObjectsModel();
    const resourcePersistQuery: TargetObjectData[][] = [[]];
    removedMembers.forEach((removedMember) => {
      const item = this.measure.MeasureResources?.find(
        (item) => item.Member === removedMember.Id,
      );
      const resourceIdToBeDeleted = item?.Id;

      if (resourceIdToBeDeleted) {
        const resourcePersistObjectData: TargetObjectData =
          new TargetObjectData();
        resourcePersistObjectData.Mode = PersistMode.Delete;
        resourcePersistObjectData.ObjectKey = new ObjectKey();
        resourcePersistObjectData.ObjectKey.ObjectType = ObjectKeys.RESOURCE;
        resourcePersistObjectData.ObjectKey.Id = resourceIdToBeDeleted;
        resourcePersistQuery[0].push(resourcePersistObjectData);
      }
    });

    query.Objects = resourcePersistQuery;
    return this.persistenceService.executePersistObjectsQuery(query);
  }

  private persistResource(members): Observable<any> {
    const query: PersistObjectsModel = new PersistObjectsModel();
    const resourcePersistQuery: TargetObjectData[][] = [[]];
    members.forEach((newMember) => {
      const resourcePersistObjectData: TargetObjectData =
        new TargetObjectData();
      resourcePersistObjectData.Mode = PersistMode.Insert;
      resourcePersistObjectData.ObjectKey = new ObjectKey();
      resourcePersistObjectData.ObjectKey.ObjectType = ObjectKeys.RESOURCE;
      const collaboratorColumns: TargetColumnValue[] = [
        { Name: "ParentId", Value: this.measure.Id },
        { Name: "IdRefPerson", Value: newMember.Id },
      ];
      resourcePersistObjectData.TargetColumns = collaboratorColumns;
      resourcePersistQuery[0].push(resourcePersistObjectData);
    });

    query.Objects = resourcePersistQuery;
    return this.persistenceService.executePersistObjectsQuery(query);
  }

  public toggleTitle = (): void => {
    this.toogleTitleVisible = !this.toogleTitleVisible;
  };

  public toggleInformations = (): void => {
    this.toogleInformations = !this.toogleInformations;
  };

  public setResponsible(e) {
    return e ? e.id : null;
  }

  private prepareMeasureIds = (): void => {
    this.subscriptions.push(
      this.measureService
        .prepareMeasuresByProjectId(this.measureColumns)
        .subscribe(
          (measures) => {
            if (Array.isArray(measures) && measures.length > 0) {
              measures.forEach((item) => {
                this.appService.measureIds.push(item.Id);
              });
              this.prepareMeasureDesignation();
            }
          },
          (error) => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
            this.appService.showLoader(false);
            console.error(error);
          },
          () => {
            this.prepareNavigationIndex();
            this.appService.showLoader(false);
          },
        ),
    );
  };

  private prepareMeasureDesignation = (): void => {
    const measureIdIndex = this.appService.measureIds.findIndex(
      (_id) => _id === this.measureId,
    );
    const previousNextMeasureIds = [
      this.appService.measureIds[measureIdIndex - 1],
      this.appService.measureIds[measureIdIndex + 1],
    ];
    const measureDesignationOpath = ` Id In (${previousNextMeasureIds.map((ids) => "'" + ids + "'")})`;
    this.dataService
      .readObjects(
        ObjectKeys.MEASURE,
        this.measureService.measureDesignationColumns,
        measureDesignationOpath,
      )
      .subscribe((_data) => {
        this.previousMeasureDesignation = _data[0]?.Designation;
        this.nextMeasureDesignation = _data[1]?.Designation;
        this.cdr.markForCheck();
      });
  };

  private loadMeasureProgress = () => {
    if (this.measure.MeasureProgress?.length > 0) {
      this.appService.currentMeasureProgressIndex.set(
        this.measure.MeasureProgress.length - 1,
      );
      this.lastMeasureProgress.Id =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].Id;
      this.lastMeasureProgress.Progress =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].Progress;
      this.lastMeasureProgress.Decision =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].Decision;
      this.lastMeasureProgress.NextSteps =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].NextSteps;
      this.lastMeasureProgress.MaturityLevel =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].MaturityLevel;
      this.lastMeasureProgress.RiskAndChance =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].RiskAndChance;
      this.lastMeasureProgress.ProgressPercentage =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].ProgressPercentage;
      this.lastMeasureProgress.ProgressDate =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].ProgressDate;
      this.lastMeasureProgress.Properties =
        this.measure.MeasureProgress[
          this.measure.MeasureProgress.length - 1
        ].Properties;
      this.statusReport.lastMeasureProgress = this.lastMeasureProgress;
    } else {
      this.appService.currentMeasureProgressIndex.set(-1);
      this.measure.MeasureProgress = [];
      this.lastMeasureProgress = new MeasureProgress(null);
      this.lastMeasureProgress.ProgressPercentage = 0;
      this.lastMeasureProgress.MaturityLevel =
        this.measureService.maturityLevel[0].name;
    }
    this.appService.showLoader(false);
    this.cdr.detectChanges();
  };

  public backToMeasureList(): void {
    this.dataService.appService.showMeasureIcon = false;
    if (this.returnPath === "subProject") {
      this.router.navigate(["subProjectDetail", this.measure.ParentId]);
    } else {
      this.router.navigateByUrl(this.returnPath);
    }
  }

  public clearProgressFileds = (): void => {
    if (this.workOnLastStatus == false) {
      this.lastMeasureProgress = new MeasureProgress(null);
    } else {
      delete this.lastMeasureProgress["meta"];
      delete this.lastMeasureProgress.Id;
    }
    this.isNewMeasureTask = true;
    this.lastMeasureProgress.ProgressDate = new Date();
  };

  public navigateToMeasure = (index: number): void => {
    this.appService.showLoader(true);
    this.measureService.currentMeasureIndex += index;
    this.measureService.currentMeasureId.set(
      this.appService.measureIds[this.measureService.currentMeasureIndex],
    );
    this.measureId = this.measureService.currentMeasureId();
    this.router.navigate([
      "measureDetail",
      "measures",
      this.measureService.currentMeasureId(),
    ]);
    this.prepareCurrentMeasure();
    this.prepareMeasureDesignation();
  };

  private prepareNavigationIndex() {
    this.measureService.currentMeasureIndex = this.measureService
      .selectedMeasures
      ? this.measureService.selectedMeasures.findIndex(
          (measure) => measure.Id == this.measureId,
        )
      : this.appService.measureIds.findIndex(
          (measureId) => measureId == this.measureId,
        );
    this.navigationMaximumIndex = this.measureService.selectedMeasures
      ? this.measureService.selectedMeasures.length - 1
      : this.appService.measureIds.length - 1;
    this.cdr.markForCheck();
  }

  private prepareMeasureDetailColumns(measureId: string): QueryObjectsModel {
    const measure: Query = new Query();
    this.measureColumns = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("ParentId", "ParentId"),
      this.coreDataService.createQueryColumn("Designation", "Title"),
      this.coreDataService.createQueryColumn("StartDate", "StartDate"),
      this.coreDataService.createQueryColumn("Status", "Status"),
      this.coreDataService.createQueryColumn(
        "IdRefPersonResponsible",
        "Responsible",
      ),
      this.coreDataService.createQueryColumn(
        "IdRefPersonAreaManager",
        "AreaManager",
      ),
      this.coreDataService.createQueryColumn(
        "IdRefPersonSponsor",
        "IdRefPersonSponsor",
      ),
      this.coreDataService.createQueryColumn("EndDate", "EndDate"),
      this.coreDataService.createQueryColumn(
        "InitialSituation",
        "InitialSituation",
      ),
      this.coreDataService.createQueryColumn(
        "ExpectedResults",
        "ExpectedResults",
      ),
      this.coreDataService.createQueryColumn("Goal", "Goal"),
      this.coreDataService.createQueryColumn("Dependencies", "Dependencies"),
      this.coreDataService.createQueryColumn("Concept", "Concept"),
      this.coreDataService.createQueryColumn("SysDateInsert", "ReleaseDate"),
      this.coreDataService.createQueryColumn("Benefit", "Benefit"),
      this.coreDataService.createQueryColumn("Effort", "Effort"),
      this.coreDataService.createQueryColumn("TotalScore", "TotalScore"),
      this.coreDataService.createQueryColumn("Impact", "Impact"),
      this.coreDataService.createQueryColumn("Cost", "Cost"),
      this.coreDataService.createQueryColumn(
        "DefenseMeasures",
        "DefenseMeasures",
      ),
    ];
    measure.ObjectType = ObjectKeys.MEASURE;
    if (measureId) {
      this.measureColumns.push(
        this.coreDataService.createQueryColumn(
          "Count(Documents)",
          "documentsNumber",
        ),
      );
    }
    measure.Columns = this.measureColumns;
    measure.OPath = "Id=" + "'" + measureId + "'";

    const measureTask: Query = new Query();
    measureTask.Name = "MeasureTasks";
    measureTask.OPath = "MeasureTasks";
    const measureTaskColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("ParentId", "ParentId"),
      this.coreDataService.createQueryColumn(
        "Subject",
        "Label",
        QueryColumnSortOrder.Ascending,
      ),
      this.coreDataService.createQueryColumn("StartDate", "StartDate"),
      this.coreDataService.createQueryColumn("EndDate", "EndDate"),
      this.coreDataService.createQueryColumn("FinishedOn", "FinishedOn"),
      this.coreDataService.createQueryColumn("IdRefResponsible", "Responsible"),
      this.coreDataService.createQueryColumn(
        "TargetMaturityLevel",
        "TargetMaturityLevel",
      ),
      this.coreDataService.createQueryColumn(
        "DegreeOfImplementation",
        "DegreeOfImplementation",
      ),
      this.coreDataService.createQueryColumn(
        "TotalTimeRequired",
        "TotalTimeRequired",
      ),
      this.coreDataService.createQueryColumn("Type", "Type"),
      this.coreDataService.createQueryColumn("Status", "Status"),
      this.coreDataService.createQueryColumn("Comment", "Comment"),
    ];

    measureTask.Columns = measureTaskColumns;
    measureTask.Columns.push(
      this.coreDataService.createQueryColumn("IdRefxmtMeasureTask", "Task"),
    );

    const measureProgress: Query = new Query();
    measureProgress.Name = "MeasureProgress";
    measureProgress.OPath = "MeasureProgresses";
    this.measureProgressColumns = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("Decision", "Decision"),
      this.coreDataService.createQueryColumn("MaturityLevel", "MaturityLevel"),
      this.coreDataService.createQueryColumn("NextSteps", "NextSteps"),
      this.coreDataService.createQueryColumn("Progress", "Progress"),
      this.coreDataService.createQueryColumn(
        "ProgressDate",
        "ProgressDate",
        QueryColumnSortOrder.Ascending,
      ),
      this.coreDataService.createQueryColumn(
        "SysTimeInsert",
        "SysTimeInsert",
        QueryColumnSortOrder.Ascending,
      ),
      this.coreDataService.createQueryColumn(
        "ProgressPercentage",
        "ProgressPercentage",
      ),
      this.coreDataService.createQueryColumn("RiskAndChance", "RiskAndChance"),
    ];
    measureProgress.Columns = this.measureProgressColumns;
    const propertiesQuery: Query = new Query();
    propertiesQuery.ObjectType = ObjectKeys.PROPERTY;
    const propertyColumns: QueryColumn[] = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("Designation", "Designation"),
    ];
    propertiesQuery.Columns = propertyColumns;
    propertiesQuery.OPath = `Properties`;
    propertiesQuery.Name = "Properties";
    measureProgress.ObjectQueries = [propertiesQuery];
    const measureResources: Query = new Query();
    measureResources.Name = "MeasureResources";
    measureResources.OPath = "MeasureResources";
    const measureResourcesColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("IdRefPerson", "Member"),
      this.coreDataService.createQueryColumn("ref:IdRefPerson", "Person"),
    ];
    measureResources.Columns = measureResourcesColumns;

    const taskCollaborators: Query = new Query();
    taskCollaborators.Name = "Collaborators";
    taskCollaborators.OPath = "collaborators";
    const taskCollaboratorsColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("ParentId", "ParentId"),
      this.coreDataService.createQueryColumn(
        "IdRefMeasureResource",
        "IdRefMember",
      ),
      this.coreDataService.createQueryColumn("TimeExecuted", "TimeExecuted"),
      this.coreDataService.createQueryColumn("TimePlanned", "TimePlanned"),
    ];
    taskCollaborators.Columns = taskCollaboratorsColumns;

    const ratingComment: Query = new Query();
    ratingComment.ObjectType = ObjectKeys.COMMENT;
    const ratingCommentColumns: QueryColumn[] = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("Comment", "Comment"),
      this.coreDataService.createQueryColumn("Text", "Text"),
      this.coreDataService.createQueryColumn("ParentId", "ParentId"),
    ];
    ratingComment.Columns = ratingCommentColumns;
    ratingComment.OPath = "Comments[Identifier Like 'MeasureRatingComment']";
    ratingComment.Name = "Comment";

    measureTask.ObjectQueries = [taskCollaborators];
    measure.ObjectQueries = [
      measureTask,
      measureProgress,
      measureResources,
      ratingComment,
    ];
    const measureDetailColumns = new QueryObjectsModel();
    measureDetailColumns.ObjectQueries = [measure];
    return measureDetailColumns;
  }

  private prepareMeasureProgress(opath: string): Observable<ArrayBuffer> {
    const measureProgressColumns = new QueryObjectsModel();

    const measureProgress: Query = new Query();
    measureProgress.ObjectType = ObjectKeys.MEASUREPROGRESS;
    measureProgress.OPath = opath;
    this.measureProgressColumns = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("Decision", "Decision"),
      this.coreDataService.createQueryColumn("MaturityLevel", "MaturityLevel"),
      this.coreDataService.createQueryColumn("NextSteps", "NextSteps"),
      this.coreDataService.createQueryColumn("Progress", "Progress"),
      this.coreDataService.createQueryColumn(
        "ProgressDate",
        "ProgressDate",
        QueryColumnSortOrder.Ascending,
      ),
      this.coreDataService.createQueryColumn(
        "SysTimeInsert",
        "SysTimeInsert",
        QueryColumnSortOrder.Ascending,
      ),
      this.coreDataService.createQueryColumn(
        "ProgressPercentage",
        "ProgressPercentage",
      ),
      this.coreDataService.createQueryColumn("RiskAndChance", "RiskAndChance"),
    ];
    measureProgress.Columns = this.measureProgressColumns;
    const propertiesQuery: Query = new Query();
    propertiesQuery.ObjectType = ObjectKeys.PROPERTY;
    const propertyColumns: QueryColumn[] = [
      this.coreDataService.createQueryColumn("Id", "Id"),
      this.coreDataService.createQueryColumn("Designation", "Designation"),
    ];
    propertiesQuery.Columns = propertyColumns;
    propertiesQuery.OPath = `Properties`;
    propertiesQuery.Name = "Properties";
    measureProgress.ObjectQueries = [propertiesQuery];
    measureProgressColumns.ObjectQueries = [measureProgress];
    return this.coreDataService.executeReadObjectsQuery(measureProgressColumns);
  }
  public assignReportToMeasure(reportId: string) {
    const opath = "Id=" + "'" + reportId + "'";
    this.subscriptions.push(
      this.prepareMeasureProgress(opath).subscribe(
        (data) => {
          this.measure.MeasureProgress.push(data[0]);
          this.measureService.currentMeasure.set({ ...this.measure });
          this.loadMeasureProgress();
          this.chart.prepareChart();
          this.notificationService.callNotification({
            message: NotificationMessage.ValidUploadMessage,
            type: ToastType.SUCCESS,
          });
        },
        (error) => {
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
          console.error(error);
        },
      ),
    );
  }

  public updateReportData(report: MeasureProgress) {
    this.measure.MeasureProgress.forEach((item, index) => {
      if (item.Id === report.Id) {
        this.measure.MeasureProgress[index] = report;
        this.chart.prepareChart();
      }
    });
  }

  public deleteReport(reportId: string) {
    const index = this.measure.MeasureProgress.findIndex(
      (item) => item.Id === reportId,
    );

    this.measure.MeasureProgress.splice(index, 1);
    this.measureService.currentMeasure.set({ ...this.measure });
    if (index >= this.measure.MeasureProgress.length)
      this.currentProgressIndex.set(index - 1);
    this.chart.prepareChart();
  }
  public checkSubprojectOpath(): string {
    return this.opathService.checkSubprojectOPath();
  }

  protected updateMeasureProgress(value: string) {
    this.measure.MeasureProgress[this.currentProgressIndex()].MaturityLevel =
      value;
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }
}

export interface CollaboratorPlannedTime {
  collaborator: string;
  totalPlannedTime: number;
}
